import { render } from "./EmojisAnimation.vue?vue&type=template&id=3cea31f0"
import script from "./EmojisAnimation.vue?vue&type=script&lang=js"
export * from "./EmojisAnimation.vue?vue&type=script&lang=js"

import "./EmojisAnimation.vue?vue&type=style&index=0&id=3cea31f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__